import {IconButton} from '@mui/material';
import {FC} from 'react';

import {KIconCheckmark, KIconEnvelopeDot} from '@/components/icons/fa';
import {useInbox} from '@trycourier/react-hooks';
import {NotificationBadgeProps} from './types';

export type NotificationReadUnreadProps = NotificationBadgeProps;

/**
 * Notification show read/unread and mark read/unread
 */
export const NotificationReadUnread: FC<NotificationReadUnreadProps> = ({message, onChangeMessage}) => {
  const inbox = useInbox();

  const markUnread = async (id: string) => {
    await inbox.markMessageUnread(id);
    message.read = false;
    onChangeMessage?.(message);
  };

  const markRead = async (id: string) => {
    await inbox.markMessageRead(id);
    message.read = true;
    onChangeMessage?.(message);
  };

  return message.read ? (
    <IconButton
      color={'primary'}
      onClick={(event) => {
        event.stopPropagation();
        return markUnread(message.id);
      }}
      data-testid={`notification-${message.id}-mark-unread`}
      title={'Mark Unread'}
    >
      <KIconCheckmark fontSize="small" color={'primary'} data-testid={`notification-${message.id}-read`} />
    </IconButton>
  ) : (
    <IconButton
      color={'primary'}
      onClick={(event) => {
        event.stopPropagation();
        return markRead(message.id);
      }}
      data-testid={`notification-${message.id}-mark-read`}
      title={'Mark as Read'}
    >
      <KIconEnvelopeDot fontSize="small" color={'primary'} data-testid={`notification-${message.id}-unread`} />
    </IconButton>
  );
};
